<template>
    <Main>
        <box-loading v-if="isLoading"></box-loading>
        <div v-else class="px-0 px-sm-3 box-settings">
            <div class="d-flex justify-content-end">
                <a class="text-primary text-guide" target="_blank" href="./pdf/KB_Kintone設定マニュアル.pdf">
                    {{ $t('setting.settingAccount.guide') }}
                </a>
            </div>
            <form autocomplete="off">
                <InputField classes="mb-sm-4 mb-2" is-required :label-text="$t('setting.settingAccount.domain')">
                    <InputText :readonly="(userInfo.url_kintone !== null && userInfo.url_kintone !== '') || readonly" v-model="account.url_kintone"> </InputText>
                    <template #error v-if="errorInfo.url_kintone">{{ errorInfo.url_kintone }}</template>
                </InputField>
                <InputField classes="mb-sm-4 mb-2" is-required :label-text="$t('setting.settingAccount.id')">
                    <InputText v-model="account.id" :readonly="readonly" @keyup.native="onValidate('id')" @keydown.native="onValidate('id')"></InputText>
                    <template #error v-if="errorInfo.id">{{ errorInfo.id }}</template>
                </InputField>
                <InputField classes="mb-sm-4 mb-2" is-required :label-text="$t('pageLogin.password')">
                    <div class="input-group input-group__password">
                        <input
                            :type="isShowPassword ? 'text' : 'password'"
                            id="password-kintone"
                            autocomplete="new-password"
                            :readonly="readonlyPassword"
                            v-model="account.password"
                            @keydown="onValidate('password')"
                            @keyup="onValidate('password')"
                            class="form-control"
                            :class="{ 'input-valid': errorInfo.password }"
                        />
                        <span class="password-icon" v-if="!readonlyPassword">
                            <i @click="isShowPassword = !isShowPassword" class="fas" :class="{ 'fa-eye': isShowPassword, 'fa-eye-slash': !isShowPassword }"></i>
                        </span>
                    </div>
                    <template #error v-if="errorInfo.password">{{ errorInfo.password }}</template>
                </InputField>
            </form>
            <div class="text-right">
                <Button type="primary" @click="handleChangePassword" v-if="!checkSettingKinton && !checkUpdatePassword">
                    {{ $t('textSaveSetting') }}
                </Button>
                <Button type="primary" classes="ml-2" @click="handleUpdatePassword" v-if="!checkSettingKinton && checkUpdatePassword">
                    {{ $t('textSaveSetting') }}
                </Button>
                <Button classes="ml-2" v-if="checkSettingKinton" @click="handleSettingKintone" type="primary">
                    {{ $t('setting.settingAccount.setting') }}
                </Button>
                <Button classes="ml-2" v-else @click="handleCancelKintone" type="warning">
                    {{ $t('setting.settingAccount.cancel') }}
                </Button>
            </div>
        </div>
    </Main>
</template>

<script>
import Main from '@/components/partials/layout/Main';
import InputField from '@/components/partials/InputField';
import InputText from '@/components/partials/customs/InputText';
import { mapState } from 'vuex';
import Button from '@/components/partials/Button';
import { isEmpty, validMaxLength, validRequired } from '@/utils';
import BoxLoading from '@/components/partials/BoxLoading';

export default {
    name: 'Setting',
    components: {
        BoxLoading,
        Button,
        InputField,
        Main,
        InputText
    },
    data() {
        return {
            language: 'ja',
            account: {
                id: '',
                password: '',
                url_kintone: ''
            },
            errorInfo: {
                id: '',
                password: '',
                url_kintone: ''
            },
            isShowPassword: false,
            readonlyPassword: false,
            checkSettingKinton: true,
            checkUpdatePassword: false,
            isLoading: false,
            idSetting: '',
            readonly: false
        };
    },
    computed: {
        ...mapState('auth', ['userInfo'])
    },
    created() {
        this.handleGetAccountKintone();
    },
    mounted() {},
    methods: {
        handleGetAccountKintone() {
            this.isLoading = true;
            let successCallback = (response) => {
                this.isLoading = false;
                this.id = '';
                this.idSetting = '';
                this.password = '';
                this.checkSettingKinton = true;
                this.readonly = false;
                this.readonlyPassword = false;
                let { data } = response.data;
                let { setting } = data;
                if (!isEmpty(setting)) {
                    let { setting } = data;
                    this.idSetting = setting.id;
                    this.account.id = setting.username;
                    this.account.url_kintone = setting.domain;

                    this.readonly = true;
                    this.readonlyPassword = true;
                    this.checkSettingKinton = false;
                    this.account.password = '***************';
                }
                if (this.userInfo && this.userInfo.url_kintone) {
                    this.account.url_kintone = this.userInfo.url_kintone;
                }
                this.getDataVerify();
            };
            let errorCallback = () => {
                this.isLoading = false;
            };
            let payload = {
                successCallback,
                errorCallback
            };
            this.$store.dispatch('settingAccount/getKintone', payload);
        },
        onValidate(field) {
            let check = true;
            let { account } = this;
            if (field === 'urlLink' || !field) {
                if (!validRequired(account.url_kintone)) {
                    this.errorInfo.url_kintone = this.$t('setting.settingAccount.errDomain');
                    check = false;
                } else if (!validMaxLength(account.url_kintone, 255)) {
                    this.errorInfo.url_kintone = this.$t('setting.errDomainMaxLength');
                    check = false;
                } else {
                    this.errorInfo.url_kintone = '';
                }
            }
            if (field === 'id' || !field) {
                if (!validRequired(account.id)) {
                    this.errorInfo.id = this.$t('setting.settingAccount.errID');
                    check = false;
                } else if (!validMaxLength(account.id, 255)) {
                    this.errorInfo.id = this.$t('setting.IDMaxLengthErr');
                    check = false;
                } else {
                    this.errorInfo.id = '';
                }
            }
            if (field === 'password' || !field) {
                if (!validRequired(account.password)) {
                    this.errorInfo.password = this.$t('pageLogin.errorPass');
                    check = false;
                } else if (!validMaxLength(account.password, 255)) {
                    this.errorInfo.password = this.$t('setting.passwordMaxLengthErr');
                    check = false;
                } else {
                    this.errorInfo.password = '';
                }
            }

            return check;
        },
        getDataVerify() {
            let successCallback = (response) => {
                if (response.status === 200) {
                    let { user } = response.data.data;
                    this.$store.commit('auth/auth_success', { userInfo: user });
                    localStorage.setItem('KB_DEV_CUSTOMER', JSON.stringify(user));
                }
            };
            let errorCallback = () => {
                this.$store.commit('auth/auth_error');
            };
            let payload = {
                successCallback,
                errorCallback
            };
            this.$store.dispatch('auth/verify', payload);
        },
        handleSettingKintone() {
            let check = this.onValidate();
            if (check) {
                if (this.isLoading) return;
                this.isLoading = true;
                let successCallback = (response) => {
                    if (response.status === 200) {
                        this.handleGetAccountKintone();
                        this.$store.commit('noticeSystem/SET_MESSAGE', {
                            isShowMessage: true,
                            type: 'success',
                            message: this.$t('setting.settingAccount.successKintone')
                        });
                        setTimeout(() => {
                            location.reload();
                        }, 1000);
                    }
                    this.isLoading = false;
                };
                let errorCallback = () => {
                    this.isLoading = false;
                };
                let { account } = this;
                let payload = {
                    data: {
                        domain: account.url_kintone ? account.url_kintone.trim() : null,
                        username: account.id ? account.id.trim() : null,
                        password: account.password ? account.password.trim() : null
                    },
                    successCallback,
                    errorCallback
                };
                this.$store.dispatch('settingAccount/settingKintone', payload);
            }
        },

        handleCancelKintone() {
            this.$store.commit('noticeSystem/SET_CONFIRM', {
                type: `warning`,
                isShowConfirm: true,
                message: this.$t('setting.settingAccount.cancelAccount'),
                callback: () => {
                    this.cancelKintoneCallback();
                }
            });
        },

        cancelKintoneCallback() {
            let successCallback = () => {
                this.handleGetAccountKintone();
                this.$store.commit('noticeSystem/SET_MESSAGE', {
                    isShowMessage: true,
                    type: 'success',
                    message: this.$t('setting.msgKintoneCancel')
                });
                setTimeout(() => {
                    location.reload();
                }, 1000);
            };

            let errorCallback = () => {};

            let payload = {
                successCallback,
                errorCallback
            };
            this.$store.dispatch('settingAccount/cancelKintone', payload);
        },
        handleChangePassword() {
            this.readonlyPassword = false;
            this.account.password = '';
            this.checkUpdatePassword = true;
        },
        handleUpdatePassword() {
            let check = this.onValidate();
            if (check) {
                if (this.isLoading) return;
                this.isLoading = true;
                let successCallback = (response) => {
                    if (response.status === 200) {
                        this.handleGetAccountKintone();
                        this.$store.commit('noticeSystem/SET_MESSAGE', {
                            isShowMessage: true,
                            type: 'success',
                            message: this.$t('setting.msgUpdatePasswordSuccess')
                        });
                        this.readonlyPassword = true;
                        this.checkUpdatePassword = false;
                        this.isLoading = false;
                    }
                };
                let errorCallback = () => {
                    this.errorInfo.password = '';
                    this.readonlyPassword = false;
                    this.checkUpdatePassword = true;
                    this.isLoading = false;
                };
                let { account } = this;
                let payload = {
                    data: {
                        id: this.idSetting,
                        domain: this.userInfo.url_kintone,
                        username: account.id ? account.id.trim() : null,
                        password: account.password ? account.password.trim() : null
                    },
                    successCallback,
                    errorCallback
                };
                this.$store.dispatch('settingAccount/settingPasswordKintone', payload);
            }
        }
    }
};
</script>
